import React from "react";
import ContactPage from "./home_data/ContactPage";

// loading assets
import "./Contact.scss";

const Contact = () => {
  return (
    <div className="main-background">
      <ContactPage />
    </div>
  );
};

export default Contact;
